import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

const getInitial = () => {
  if (typeof window !== "undefined") {
    const saved = window.localStorage.getItem("sc_lang");
    if (saved && translations[saved]) return saved;
  }
  return "it";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitial);

  const changeLang = useCallback((code) => {
    if (translations[code]) {
      setLang(code);
      window.localStorage.setItem("sc_lang", code);
    }
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
